export default "__VITE_ASSET__0d10b75c__"